module.exports = __webpack_public_path__ + "static/media/pvc.6b856c67.jpg";